/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch, useSelector } from 'react-redux';
import { selectTemplates, selectSelectedTemplate, setSelectedTemplate } from '../../redux/reducers/templateSlice';
import { Button } from "@/subframe/components/Button";
import { RadioCardGroup } from "@/subframe/components/RadioCardGroup";
import { Image, FileText, Video } from 'lucide-react';
import * as SubframeCore from "@subframe/core";

const TemplateList = () => {
  const dispatch = useDispatch();
  const templates = useSelector(selectTemplates);
  const selectedTemplate = useSelector(selectSelectedTemplate);

  const renderHeaderMedia = (component: any) => {
    if (!component?.format) return null;

    switch (component.format.toLowerCase()) {
      case 'image':
        return (
          <div className="h-48 w-full flex-none rounded-t-lg bg-neutral-100 flex flex-col items-center justify-center">
            <Image className="w-16 h-16 text-neutral-400" />
            <span className="mt-2 text-sm text-neutral-500">Video Preview</span>
          </div>
        );
      case 'video':
        return (
          <div className="h-48 w-full flex-none rounded-t-lg bg-neutral-100 flex flex-col items-center justify-center">
            <Video className="w-16 h-16 text-neutral-400" />
            <span className="mt-2 text-sm text-neutral-500">Video Preview</span>
          </div>
        );
      case 'document':
        return (
          <div className="h-48 w-full flex-none rounded-t-lg bg-neutral-100 flex flex-col items-center justify-center">
            <FileText className="w-16 h-16 text-neutral-400" />
            <span className="mt-2 text-sm text-neutral-500">Document Preview</span>
          </div>
        );
      default:
        return null;
    }
  };



  const renderTemplateCard = (template: any) => {
    const headerComponent = template.components.components.find((comp: any) => comp.type === 'HEADER');
    const bodyComponent = template.components.components.find((comp: any) => comp.type === 'BODY');
    const buttonComponent = template.components.components.find((comp: any) => comp.type === 'BUTTONS');
   
    const formatText = (text: string) => {
      if (!text) return '';
      const rtlLanguages = ['ar', 'he', 'ur', 'fa'];
      const textDirection = rtlLanguages.includes(template?.language?.toLowerCase()) ? 'rtl' : 'ltr';
      
      return (
        <span
          className={`whitespace-pre-wrap w-full text-xs leading-relaxed ${textDirection === 'rtl' ? 'text-rtl' : 'text-ltr'}`}
          dangerouslySetInnerHTML={{
            __html: text.split('\n').join('<br />')
          }}
        />
      );
    };
   
    return (
      <div 
        key={template.id}
        className={`flex flex-col items-start gap-4 self-stretch rounded-md border border-solid 
          ${selectedTemplate?.id === template.id ? 'border-brand-600' : 'border-neutral-border'} 
          bg-default-background px-2 py-2 shadow-sm cursor-pointer w-full`}
        onClick={() => dispatch(setSelectedTemplate(template))}
      >
        <div className="flex w-full flex-col items-center justify-center rounded-lg border border-solid border-neutral-border bg-[#eae7dcff] p-2">
        <div className="flex w-full flex-col items-center justify-center rounded-lg border border-solid border-neutral-border bg-[#ffffffff] shadow-lg">
          {renderHeaderMedia(headerComponent)}
          <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-6 px-4 pt-4 pb-0.5">
            {formatText(bodyComponent?.text)}
          </div>
          <div className="flex w-full flex-col items-start">
            {buttonComponent?.buttons?.map((button: any, index: any) => (
              <div key={index} className="flex w-full flex-col items-center justify-center gap-2 border-t-2 border-solid border-neutral-border px-3 py-3">
                <div className="flex items-center gap-2">
                  <SubframeCore.Icon
                    className="text-heading-3 font-heading-3 text-[#10b989ff]"
                    name={
                      button.type === 'QUICK_REPLY' ? 'FeatherReply' :
                      button.type === 'URL' ? 'FeatherArrowUpRightSquare' :
                      button.type === 'PHONE_NUMBER' ? 'FeatherPhone' :
                      button.type === 'COPY_CODE' ? 'FeatherCopy' : 'FeatherList'
                    }
                  />
                  <span className="font-['Nunito'] text-xs font-[600] leading-[20px] text-success-500">
                    {button.text}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
        <span className="w-full text-caption font-caption text-default-font">
          {template.category}
        </span>
        <div className="w-full text-body-bold font-body-bold text-default-font break-words">
        {template.name}
        </div>
        <Button
          variant="brand-tertiary"
          size="small"
          icon="FeatherEye"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(setSelectedTemplate(template));
          }}
          className="w-full"
        >
          Preview
        </Button>
      </div>
    );
   };

  return (
    <div className="conveythis-no-translate w-full px-4 py-4">
      <RadioCardGroup
        className="w-full"
        value=""
        onValueChange={() => {}}
      >
        <div className="grid grid-cols-3 gap-4">
          {templates.map(renderTemplateCard)}
        </div>
      </RadioCardGroup>
    </div>
  );
};

export default TemplateList;